export default `
# 法务合规 数据安全保障

<a name="eDaAF"></a>
## 1 前言
大搜车·开放平台对数据安全保障从如下 3 个方面展开：

1. 用户身份识别以及访问权限控制
1. 数据传输通道加密
1. 服务安全预警

大搜车·开放平台由专人负责日常维护开发，依托大搜车的研发保障体系，持续强化数据安全保障。
<a name="Vz06b"></a>
### 1.1  术语定义
**开放平台**：大搜车内部业务数据内外交互的统一管控中心<br />**全链路**：从用户端到服务端的数据交互全路径<br />**租户： **外部平台接入大搜车·开放平台所分配的账号<br />**工单**：开放平台内部业务流转单元<br />**域**：搜车内部服务主体单元<br />**阿里云：**目前为大搜车提供云计算能力的服务供应商<br />				
			
		
	
<a name="QRQRP"></a>
## 2 全链路安全防护
<a name="NbM2c"></a>
### 2.1 访问控制
<a name="nmUEp"></a>
#### 2.1.1 权限控制
外部业务方接入大搜车·开放平台必须申请租户账号，走工单审批，经由内部对接业务方和开放平台审核通过后，有开放平台统一分配账号。如外部接入方存在违规行为，经业务方授权，大搜车·开放平台执行租户账号回收操作，停止对外部接入方服务供应，及时止损。开放平台内部通过 API 以及 API 组授权的方式，以最小化权限的原则，管控外部接入方可以访问的 API，权限可按内部业务方需求，随时进行调整。
<a name="ADZv6"></a>
#### 2.1.2 流量控制
为防止外部接入方恶意批量获取数据，以及保障其他租户的服务可用性。大搜车·开放平台设置有流量控制模块，可以从租户级别、API 级别进行流量限制，包括分钟流控、频率间隔流控等，发现异常情况，立即通知相关内部业务方和大搜车·开放平台相关开发进行响应处理。
<a name="WjnrZ"></a>
#### 2.1.3 多环境隔离
针对大搜车内部复杂的网络环境，开放平台对不同域之间的访问做了环境隔离，保障数据安全。
<a name="tBwUM"></a>
### 2.2 基础设施安全
<a name="BDqhZ"></a>
#### 2.2.1 主机安全
大搜车·开放平台任一子模块，至少双机互备。并配备有阿里云的服务可用性检测、主机存活检测、硬件资源负载检测等，一旦发现异常情况，立即通过短信、邮件、钉钉消息进行告警，确保相关人员迅速处理。
<a name="Duocg"></a>
#### 2.2.2 网络安全
大搜车线上环境现在采用阿里云 VPC 专线，保证网络私密性，以及内部服务之间的通讯稳定。依托阿里云的 DDOS 防御功能，清洗机器行为和恶意 Web 攻击流量，从而减轻业务服务器处理压力，从而提高业务访问的可靠性和纯净度。
<a name="drq8n"></a>
### 2.3 数据安全
大搜车以数据安全为愿景，严格遵循国家相关法律法规的各项安全要求，在数据生命周期各阶段如数据产生、数据存储、数据使用、数据传输、数据共享、数据销毁等，都无缝嵌入大搜车集团各项成熟的安全控制措施，确保用户数据的机密性、完整性、可靠性。
<a name="qU7k4"></a>
#### 2.3.1 数据传输
大搜车内外部的之间的接口通讯，必须统一经由开放平台出入，实现 TLS 加密以及证书统一管理，保障全站 https 安全访问; 面向内部涉及签名认证或加密类业务，必须统一过开放平台鉴权模块。
<a name="lLBJe"></a>
#### 2.3.2 数据安全审计
在数据生命周期，大搜车建立了全链路风险检测感知体系，通过关键词检测、行为过滤和专家运营，实时检测分析异常数据访问记录。如登录失败、权限升级、非法访问、敏感数据下载等，一旦发现异常行为及时告警，确保违规操作有迹可循。
<a name="ADFOD"></a>
#### 2.3.3 法务备案
大搜车内部有着严格的数据开放流程，如涉及到高敏数据，例如用户电话、身份信息、订单信息的开放等，均需要法务备案。由法律相关专业人员评定开放风险以及开放合理性，并酌情调整数据开放范围和类别。
<a name="7W2ip"></a>
#### 2.3.4 数据共享
在对外数据开放共享方面，大搜车严格遵循《网络安全法》要求，以用户隐私 信息保护为首要前提，制定对外数据披露细则，明确要求所有对外数据输出必须 遵循以下原则:

- 保护用户隐私:涉及用户隐私数据未经客户的充分授权，不得收集、分析或 向任何第三方输出。
- 必要性和最小化:对外数据输出时必须将数据的范围、数量及知情者控制在 最小范围内，因法律法规要求需向公众公平公开输出数据的情况除外。
- 合规性:对外数据合作必须遵循适用于大搜车集团的法律、法规、政策、行业标准等要求。

<a name="q8ibE"></a>
## 3. 安全合规
<a name="KksZ3"></a>
### 3.1 保密协议
大搜车研发与公司均签有《保密协议》，大搜车在业务开展过程中，一旦发现泄露用户隐私、恶意篡改用户数据、非授权执行违规操作等异常行为，将视情况严厉处理。
<a name="mR03M"></a>
### 3.2 操作回溯
大搜车·开放平台对用户的操作日志保留 1 个月，部分敏感业务可延长至 2 年。
`